import {
  Anchor,
  Badge,
  Divider,
  Group,
  Paper,
  Text,
  Title,
} from "@mantine/core";
import React from "react";
import SpecificJobView from "./SpecificJobView";

export const SpecificView = ({
  name,
  description,
  descriptionHeader,
  date,
  status,
  type,
  videoName,
  videoLink,
  allData,
}) => {
  console.log("allData", allData);
  return allData ? (
    <SpecificJobView data={allData} />
  ) : (
    <Paper>
      {name && (
        <Group position="apart" align="center">
          <Title order={2} className="text-dark">
            {name}
          </Title>
          {status && (
            <Badge size="xl" color={status === "active" ? "green" : "red"}>
              {status === "active" ? "Active" : "Inactive"}
            </Badge>
          )}
        </Group>
      )}
      {type && (
        <Title order={5} style={{ color: "rgb(0,0,0,0.6)" }}>
          {type}{" "}
        </Title>
      )}

      <Divider my={"lg"} />
      {description && (
        <React.Fragment>
          {descriptionHeader && (
            <Title
              order={4}
              style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}
            >
              {descriptionHeader}
            </Title>
          )}
          <Text>{description}</Text>
          {/* {descriptionHeader && <Divider mt="md" mb="md" />} */}
        </React.Fragment>
      )}
      {videoName && (
        <Group position="center">
          <Text size={20} weight={500} align="center" color="dimmed">
            Video Link:
          </Text>
          <Anchor href={videoLink} target="_blank">
            <Text size={20} weight={500} align="center" color="pink">
              {videoName}
            </Text>
          </Anchor>
        </Group>
      )}

      {date && (
        <React.Fragment>
          <Divider mt="md" mb="md" />
          <Text size={20} align="center">
            Created Date: {date ? date.split("T")[0] : "N/A"}
          </Text>
        </React.Fragment>
      )}
    </Paper>
  );
};

// DONT DELETE SAMPLE COMPONENT
//     <Paper>

// <Paper>
// <Paper>
//
// </Paper>
//
//
// <Group px={0} mx={0} spacing={3}>
//   {allData.skills.map((skill, index) => {
//     return (
//       <Badge key={index} size="lg">
//         {skill?.skills?.skillName}
//       </Badge>
//     );
//   })}
// </Group>
// </Paper>
// <Paper>
// <Badge size="lg" color={allData.remotely ? "green" : "red"}>
//   {allData.remotely ? <Check /> : <X />}
// </Badge>
// </Paper>
// </Paper>
//
//
//
//
//
//
//
//
//
